import { UpdateUserIdPostRequestModel } from "@/features/user/services/user-model";
import { UpdateUserIdApi } from "@/features/user/services/update-id-api";

// 利用者ID変更処理
export class UpdateUserIdService {
  private updateUserIdApi = new UpdateUserIdApi();

  /**
   * 利用者ID変更API実行
   */
  public async updateUserId(param: UpdateUserIdPostRequestModel) {
    return await this.updateUserIdApi.postUpdateUserId(param);
  }
}
